var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"chip-container",style:(_vm.cssVars)},[_c('span',{staticClass:"chip-label"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }